{
  "aom": "3.7.0",
  "archive": "3.7.2",
  "cairo": "1.17.8",
  "cgif": "0.3.2",
  "exif": "0.6.24",
  "expat": "2.5.0",
  "ffi": "3.4.4",
  "fontconfig": "2.14.2",
  "freetype": "2.13.2",
  "fribidi": "1.0.13",
  "gdkpixbuf": "2.42.10",
  "glib": "2.78.0",
  "harfbuzz": "8.2.0",
  "heif": "1.16.2",
  "imagequant": "2.4.1",
  "lcms": "2.15",
  "mozjpeg": "4.1.4",
  "orc": "0.4.34",
  "pango": "1.51.0",
  "pixman": "0.42.2",
  "png": "1.6.40",
  "proxy-libintl": "0.4",
  "rsvg": "2.57.0",
  "spng": "0.7.4",
  "tiff": "4.6.0",
  "vips": "8.14.5",
  "webp": "1.3.2",
  "xml": "2.11.5",
  "zlib-ng": "2.1.3"
}